import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './../http.service';

@Injectable({
  providedIn: 'root'
})
export class MachineOperatingSectorService {
  constructor(private httpService: HttpService) {}

  getOperatingSectors(): Observable<{ operatingSectors: string[] }> {
    return this.httpService.httpGet('machine/operating-sectors');
  }
}
